import React, { Component } from 'react';
import {Link, withRouter} from 'react-router-dom';
import { PageSettings } from './../../config/page-settings.js';
import Services from '../../services/service';
import artajasa from '../_layoutPublicWebVisitor/preview-template/artajasa.png';

class FormVerification extends Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);
    this.state = {
      formTitle: '',
      publicWebData: [],
      userName: '',
    };
  }

  componentDidMount() {
    const baseUrl = (window.location).href;
    const id = baseUrl.substring(baseUrl.lastIndexOf('/') + 1);
    this.getVerification(id);
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(true);
    this.context.handleSetPageContentClass('p-0');
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetPageContentClass('');
    this.context.handleSetBodyWhiteBg(false);
  }

  getVerification = (id) => {
    Services.putVerifyEmployee(id)
      .then( res => {
        this.setState({ formTitle: res.msg })
      })
      .catch(err => console.log(err))
  };

  render() {
    return(
      <form
        onSubmit={e => {
          e.preventDefault();
          this.handleSubmit()
        }}
      >
        <div className="coming-soon">
          <div className="coming-soon-header" style={{background: 'none', padding: '25px 50px 30px'}}>
            <div className="bg-cover"/>
            <div className="brand" style={{ textAlign: 'end' }}>
              <img
                style={{ width:'6%', height:'6%' }}
                src={artajasa}
              />
            </div>
            <div className="brand">
              {this.state.formTitle}
            </div>
            <div className="desc">
              Lanjutkan Login
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center" style={{padding: '50px'}}>
            <div className="d-flex justify-content-around align-self-center" style={{width: "20%"}}>
              <Link
                to={{
                  pathname: `/user/form-staff`,
                }}
              >
                <button type="button" className="btn btn-success">Login</button>
              </Link>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default withRouter(FormVerification)
